module.exports = __webpack_public_path__ + "static/Wkłady_mosiężne_do_wymienników_2-37261319e90cdabde4735e0f20879bd7.png";